module.exports = __webpack_public_path__ + "static/media/technology.56eb06d4.svg";